import PropTypes from "prop-types";
const PropTypeCheckbox = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool
};
export default PropTypeCheckbox;
